$(document).on('click', '.toggle-sidebar-btn', function(e) {
    e.preventDefault();

    // Alterna la visibilidad del sidebar en móviles y PC
    document.body.classList.toggle('toggle-sidebar');

    // Si estamos en dispositivos grandes (PC), ajusta el ancho de la columna principal
    if (window.innerWidth >= 900) {
        const selector = $('.sidebar-col-2').get(0);
        if (selector && selector.offsetWidth / selector.parentElement.offsetWidth > 0.95) {
            selector.style.width = '80%';
            selector.style.marginLeft = '20%';
        } else if (selector) {
            selector.style.width = '100%';
            selector.style.marginLeft = '0';
        }
    }
});

